import { useMemo } from 'react';
import { Gym } from '../react/types/gym';
import { useAngularService } from './get_angular_service';

const useGym = (): Gym => {
  const $rootScope = useAngularService('$rootScope');
  const gym: Gym = useMemo(() => $rootScope.gym, [$rootScope.gym]);
  return gym;
};

export default useGym;
